import { FC, useContext } from "react"
import { NavLink, useHistory } from "react-router-dom";
import { ZipProjectContext } from "./ZipProjectContext";
import { ZipProjectModuleRoutesEnum } from "./interfaces";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";
import { shouldShowZipProviderHub } from "@app/projects/zip-projects/utility";
import { setLastVisitedZipModule } from "@app/projects/zip-projects/state-management/lastVisitedZipModule";

export const ZipProjectModuleNav: FC = () => {
  const projectContext = useContext(ZipProjectContext);
  const history = useHistory();
  const { state } = projectContext;
  const featureFlags = useContext(FeatureFlagContext).enabledFeatureFlags;

  const showNetworkIntegrity = featureFlags.has(Features.DISPLAY_NETWORK_INTEGRITY_DASHBOARD_ON_ZIP_PROJECTS)
    && !!state.runConfiguration
    && (state.project?.projectRunConfigurations?.find((prc) => prc.projectRunConfigurationId === state.runConfiguration.projectRunConfigurationId)?.showNetworkIntegrityDashboard ?? false);

  // The Maps tab for Zip projects is feature-flagged while the ZIP map is built out.
  const showMapsTab = featureFlags.has(Features.ZIP_CODE_PROJECT_MAPS)
    && !state.isCompareMode
    && !state.runConfiguration.isTermed
    && !state.runConfiguration.isProjected
    && !state.runConfiguration.isProjectedTermed;

  const showProviderHub = shouldShowZipProviderHub(featureFlags, state);

  return (
    <div className="tabs-style-2">
      <div className="d-flex justify-content-between align-items-center">
        <ul className="nav nav-tabs" role="menu">
          {!!state.project && !state.loading ? (
            <>
              {showNetworkIntegrity && (
                <li className="nav-item" role="none">
                  <NavLink
                    className="nav-link"
                    activeClassName="active"
                    role="menuitem"
                    onClick={() => setLastVisitedZipModule("NetworkIntegrity")}
                    to={`/projects/${state.project.projectId}/${ZipProjectModuleRoutesEnum.NetworkIntegrity}${history.location.search}`}
                  >
                    Network Integrity
                  </NavLink>
                </li>
              )}
              <li className="nav-item" role="none">
                <NavLink
                  className="nav-link"
                  activeClassName="active"
                  role="menuitem"
                  onClick={() => setLastVisitedZipModule("Adequacy")}
                  to={`/projects/${state.project.projectId}/${ZipProjectModuleRoutesEnum.Adequacy}${history.location.search}`}
                >
                  Adequacy
                </NavLink>
              </li>
              {showMapsTab && <li className="nav-item" role="none"><NavLink className="nav-link" activeClassName="active" to={`/projects/${state.project.projectId}/${ZipProjectModuleRoutesEnum.Mapping}${history.location.search}`} role="menuitem">Maps</NavLink></li>}
              {showProviderHub && <li className="nav-item" role="none"><NavLink className="nav-link" activeClassName="active" to={`/projects/${state.project.projectId}/${ZipProjectModuleRoutesEnum.ProviderHub}${history.location.search}`} role="menuitem">Provider Hub</NavLink></li>}
              {state.shouldShowSummariesTab && <li className="nav-item" role="none"><NavLink className="nav-link" activeClassName="active" to={`/projects/${state.project.projectId}/${ZipProjectModuleRoutesEnum.Summary}`} role="menuitem">Summaries</NavLink></li>}
            </>
          ) : (
            <>
              {showNetworkIntegrity && <li className="nav-item" role="none"><span className="nav-link">Network Integrity</span></li>}
              <li className="nav-item" role="none"><span className="nav-link">Adequacy</span></li>
              {showMapsTab && <li className="nav-item" role="none"><span className="nav-link">Maps</span></li>}
              {showProviderHub && <li className="nav-item" role="none"><span className="nav-link">Provider Hub</span></li>}
              {state.shouldShowSummariesTab && <li className="nav-item" role="none"><span className="nav-link">Summaries</span></li>}
            </>
          )}
        </ul>
      </div>
    </div>
  )
}